'use strict';

var React = require('react');

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n.default = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

// tmp/Cancel24H.tsx
var SvgCancel24H = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M12 2.75A9.25 9.25 0 0 0 2.75 12a.75.75 0 0 1-1.5 0C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12c0 5.519-4.158 10.065-9.512 10.68a.75.75 0 1 1-.171-1.49A9.252 9.252 0 0 0 12 2.75Zm-1.194 3.56a.75.75 0 0 1 .918.531l1.433 5.348 3.928.804a.75.75 0 0 1-.301 1.47l-4.381-.897a.75.75 0 0 1-.575-.541l-1.553-5.796a.75.75 0 0 1 .53-.918ZM.076 21.092V22h4.906v-1.342H3.578c-.161 0-.351.011-.571.033-.22.014-.417.032-.593.054.38-.39.74-.783 1.076-1.18.336-.403.61-.803.823-1.2.22-.404.33-.797.33-1.18 0-.44-.1-.822-.297-1.146a1.945 1.945 0 0 0-.801-.769C3.2 15.09 2.799 15 2.338 15c-.498 0-.926.094-1.284.281A3.9 3.9 0 0 0 0 16.093l.878.854a3.47 3.47 0 0 1 .56-.486 1.15 1.15 0 0 1 .68-.217c.3 0 .538.09.713.27.183.174.275.43.275.769 0 .324-.128.678-.384 1.06-.256.375-.615.79-1.076 1.244-.453.448-.977.949-1.57 1.504Zm8.62-1.947H7.224l.922-1.493a29.163 29.163 0 0 0 .57-1.158h.044c-.007.216-.022.473-.044.768a16.19 16.19 0 0 0-.022.768v1.115Zm0 1.212V22h1.503v-1.645H11v-1.211h-.801V15.13H8.223l-2.546 4.133v1.092h3.018Z" }));
var Cancel24H_default = SvgCancel24H;

module.exports = Cancel24H_default;
